import {
  createShouldForwardProp,
  props,
} from "@styled-system/should-forward-prop";

import {
  borders,
  color,
  compose,
  EmotionComponent,
  flexbox,
  layout,
  position,
  shadow,
  space,
  styled,
  system,
  textTransformProp,
  theme,
  typography,
} from "@catchoftheday/theme";

import { sizeVariant } from "./styles/sizeVariant";
import { styleVariant } from "./styles/styleVariant";
import { ButtonProps } from "./types";

const shouldForwardProp = createShouldForwardProp([
  ...props,
  "color",
  "sizeVariant",
  "variant",
  "outline",
  "block",
  "textTransform",
  "hoverBorderColor",
]);

const whiteSpace = system({
  whiteSpace: {
    property: "whiteSpace",
  },
});

const styledProps = compose(
  space,
  color,
  layout,
  position,
  borders,
  flexbox,
  whiteSpace,
  typography,
  textTransformProp,
  shadow
);

export const Button: EmotionComponent<ButtonProps> = styled("button", {
  shouldForwardProp,
})<ButtonProps>`
  ${sizeVariant}
  ${styleVariant}

  ${styledProps}
`;

Button.displayName = "Button";

Button.defaultProps = {
  variant: "primary",
  sizeVariant: "md",
  block: false,
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  focusOutline: `1px solid ${theme.colors.secondary}`,
};

export default Button;
